export const customerCompanyState: { [key: string]: any } = {
    name: '',
    vatId: '',
    commercialRegisterNumber: '',
    foundingDate: '',
    streetName: '',
    houseNumber: '',
    addressAddition: '',
    postalCode: '',
    city: '',
    country: '',
    phoneNumber: '',
    emailDefault: '',
    emailInvoice: '',
    emailSepa: '',
};
